/* istanbul ignore file */
import { supportedBreakpoints as breakpointNames } from '../../shared/breakpoints';

// Defines columns for item in different breakpoints
export function columnDefinitionAtBreakpoints(columnsAtBreakpoints) {
  const columns = [];

  const firstDefinedBreakpointName = breakpointNames.find(
    (breakpoint) =>
      columnsAtBreakpoints[breakpoint] !== undefined &&
      columnsAtBreakpoints[breakpoint] !== null
  );

  if (!firstDefinedBreakpointName) {
    return breakpointNames.map(() => 1);
  }

  const firstColumnCount = columnsAtBreakpoints[firstDefinedBreakpointName];
  let previousColumnCount = null;

  for (let i = 0; i < breakpointNames.length; i++) {
    const columnCountDefined =
      columnsAtBreakpoints[breakpointNames[i]] !== undefined &&
      columnsAtBreakpoints[breakpointNames[i]] !== null;

    const previousCountDefined =
      previousColumnCount !== undefined && previousColumnCount !== null;

    if (columnCountDefined) {
      columns[i] = columnsAtBreakpoints[breakpointNames[i]];
    } else if (previousCountDefined) {
      columns[i] = previousColumnCount;
    } else {
      columns[i] = firstColumnCount;
    }

    previousColumnCount = columns[i];
  }

  return columns;
}
